module.exports = __webpack_public_path__ + "img/nianplus.421f6ef2.png";